import { render, staticRenderFns } from "./drawerDefault.vue?vue&type=template&id=3a83e7dd"
import script from "./drawerDefault.vue?vue&type=script&lang=js"
export * from "./drawerDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports